// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetSequenceNumberListRequestModel from '../../model/get-sequence-number-list-request-model';
import GetSequenceNumberListRequestDTO from '../dto/get-sequence-number-list-request-dto';

export default abstract class GetSequenceNumberListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetSequenceNumberListRequestDTO>) {
    super();
    if (data) {
      this.searchCriteria = data.searchCriteria;
      this['paging.CurrentPage'] = data['paging.CurrentPage'];
      this['paging.PageSize'] = data['paging.PageSize'];
      this['paging.IncludeCount'] = data['paging.IncludeCount'];
      this['paging.NoPaging'] = data['paging.NoPaging'];
    }
  }
  /**
  */
  'searchCriteria'?: string;
  /**
  * @type {int32}
  */
  'paging.CurrentPage'?: number;
  /**
  * @type {int32}
  */
  'paging.PageSize'?: number;
  /**
  */
  'paging.IncludeCount'?: boolean;
  /**
  */
  'paging.NoPaging'?: boolean;

  static toModel(dto: DeepPartial<GetSequenceNumberListRequestDTO>): GetSequenceNumberListRequestModel;
  static toModel(dto: DeepPartial<GetSequenceNumberListRequestDTO> | undefined | null): GetSequenceNumberListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetSequenceNumberListRequestDTO> | undefined | null): GetSequenceNumberListRequestModel | undefined {
    return dto ? new GetSequenceNumberListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetSequenceNumberListRequestModel> | GetSequenceNumberListRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'searchCriteria': unwrapped.searchCriteria,
      'paging.CurrentPage': unwrapped['paging.CurrentPage'],
      'paging.PageSize': unwrapped['paging.PageSize'],
      'paging.IncludeCount': unwrapped['paging.IncludeCount'],
      'paging.NoPaging': unwrapped['paging.NoPaging'],
    } as GetSequenceNumberListRequestDTO;
  }
}
